/**
 * Meditation icon for the "Mind Master" card — a stylized figure sitting
 * cross-legged (lotus pose) with hands resting on knees, a serene halo/aura
 * behind the head, and a lotus bloom base. Filled, colorful SVG that matches
 * the visual weight of DrawingIcon / MathIcon / LanguageIcon.
 */
export default function MeditationIcon({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Soft glowing aura behind the head */}
      <circle cx="16" cy="8" r="6" fill="#fde68a" opacity="0.55" />
      <circle cx="16" cy="8" r="4.2" fill="#fcd34d" opacity="0.65" />

      {/* Halo ring */}
      <circle
        cx="16"
        cy="8"
        r="5.6"
        fill="none"
        stroke="#f59e0b"
        strokeWidth="0.9"
        opacity="0.9"
      />

      {/* Head */}
      <circle cx="16" cy="8.6" r="2.6" fill="#fcd9b6" stroke="#7c2d12" strokeWidth="0.9" />

      {/* Body / torso — orange robe */}
      <path
        d="M11.4 18.5 C 11.4 14.2, 20.6 14.2, 20.6 18.5 L 20.6 21.5 C 20.6 22.4, 20 22.9, 19.2 22.9 L 12.8 22.9 C 12 22.9, 11.4 22.4, 11.4 21.5 Z"
        fill="#f97316"
        stroke="#7c2d12"
        strokeWidth="0.9"
        strokeLinejoin="round"
      />

      {/* Robe crease */}
      <path
        d="M13 22 L 16 19 L 19 22"
        stroke="#7c2d12"
        strokeWidth="0.7"
        fill="none"
        strokeLinecap="round"
      />

      {/* Crossed legs / lotus base — lower orange band */}
      <path
        d="M7 25 C 9 22.5, 23 22.5, 25 25 C 24 27, 20 27.8, 16 27.8 C 12 27.8, 8 27, 7 25 Z"
        fill="#fb923c"
        stroke="#7c2d12"
        strokeWidth="0.9"
        strokeLinejoin="round"
      />

      {/* Arms resting on knees */}
      <path
        d="M11.4 19.3 C 9.6 20.4, 8.7 22.2, 8.7 23.6"
        stroke="#7c2d12"
        strokeWidth="1.05"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M20.6 19.3 C 22.4 20.4, 23.3 22.2, 23.3 23.6"
        stroke="#7c2d12"
        strokeWidth="1.05"
        strokeLinecap="round"
        fill="none"
      />
      {/* Hands (mudra dots) */}
      <circle cx="8.4" cy="23.7" r="1.1" fill="#fcd9b6" stroke="#7c2d12" strokeWidth="0.7" />
      <circle cx="23.6" cy="23.7" r="1.1" fill="#fcd9b6" stroke="#7c2d12" strokeWidth="0.7" />

      {/* Lotus petals at the base */}
      <path
        d="M4.5 27 C 6 25.4, 8.5 25.4, 10 27 C 8.5 28, 6 28, 4.5 27 Z"
        fill="#c084fc"
        stroke="#6b21a8"
        strokeWidth="0.7"
      />
      <path
        d="M22 27 C 23.5 25.4, 26 25.4, 27.5 27 C 26 28, 23.5 28, 22 27 Z"
        fill="#c084fc"
        stroke="#6b21a8"
        strokeWidth="0.7"
      />

      {/* Peaceful closed eye */}
      <path
        d="M14.9 8.6 C 15.3 9, 15.6 9, 16 8.6"
        stroke="#7c2d12"
        strokeWidth="0.9"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M16 8.6 C 16.4 9, 16.7 9, 17.1 8.6"
        stroke="#7c2d12"
        strokeWidth="0.9"
        strokeLinecap="round"
        fill="none"
      />

      {/* Bindi / third-eye dot */}
      <circle cx="16" cy="7.1" r="0.55" fill="#dc2626" />
    </svg>
  );
}
